import styled from "styled-components";
// import { Link } from "react-router";

export const  StyledFullPage = styled.div`
width: 100%;
height: 100vh;
/* background-color: darkcyan; */


`
export const StyledManiPageContent = styled.div`
width: 100%;
height: calc(100vh - 80px);
margin-top: 80px;
display: flex;
gap: 60px;
/* background-color: blue; */
`

export const StyledMainPageRightSection = styled.div`

flex: 1;
margin-left: 300px;
height: calc(100vh - 100px);
/* background-color: red; */




`
export const StyledRightSectionTopTextSection = styled.div`
/* background-color: transparent; */
/* background-color: red; */
/* width: 100%; */
height: 55px;
display: flex;

gap: 10px;
`
export const StyledRightSectionTopText = styled.p`
font-size: 25px;
font-weight: 600;
`
export const StyledRightSectionTopTextEmoji = styled.span`

`
export const StyledRightControlButtonSection = styled.div`
width: 100%;
height: 55px;
/* background-color: black; */
background-color: rgba(249, 250, 251, 1);
display: flex;
flex-wrap: wrap;
align-items: center;
gap: 15px;
`
export const StyledRightControlBlueButton = styled.button`
min-width: fit-content;
height: 40px;
background-color: rgb(24, 119, 242);
color: rgb(255, 255, 255);
font-weight: 700;
border-width: 0px;
font-size: 15px;
 outline: none;
 padding: 0 10px 0 10px;
 border-radius: 10px;
 &:hover{
    cursor: pointer;
    background-color: #184FAE;
}
`
export const StyledRightControlRedButton = styled.button`
min-width: fit-content;
height: 40px;
background-color: rgb(255, 86, 48);
color: rgb(255, 255, 255);
font-weight: 700;
border-width: 0px;
font-size: 15px;
 outline: none;
 padding: 0 10px 0 10px;
 border-radius: 10px;
 &:hover{
    cursor: pointer;
    background-color: #184FAE;
}
`
export const StyledRightSectionContent = styled.div`
width: calc(100vw - 330px);
height: 100%;

padding: 0px 0px 0px 5px;
display: flex;
flex-direction: column;
gap: 25px;
`


export const StyledCardsSection = styled.div`

display: flex;
gap: 15px;
flex-wrap: wrap;
justify-content: start;
`

export const StyledSingleCards = styled.div`
background-color: #FFFFFF;
width: 220px;
height: 150px;
border-radius: 16px;
margin-top: 40px;
display: flex;
justify-content: space-around;
align-items: center;
box-shadow: rgba(145, 158, 171, 0.08) 0px 0px 2px 0px, rgba(145, 158, 171, 0.08) 0px 12px 24px -4px;
`
export const StyledCardsNumberAndTextSection = styled.div`
display: flex;
flex-direction: column;
`
export const StyledCardsNumber = styled.p`
font-size: 30px;
font-weight: 600;
`
export const StyledCardsText = styled.p`
color: #637380;
font-size: 14px;
 word-break: break-all;
`

export const StyledGraphSection = styled.div`
/* background-color: red;//#F9FAFB */
background-color: #FFFFFF;
height: 450px;
width: 100%;
/* width: 860px; */
/* position: absolute; */
/* top: 550px; */
left: 30px;
padding-left: 0;
border-radius: 16px;
box-shadow: rgba(145, 158, 171, 0.08) 0px 0px 2px 0px, rgba(145, 158, 171, 0.08) 0px 12px 24px -4px;
`
export const LineChart =styled.div`


`

export const StyledPieGraphSection = styled.div`
height: 300px;
width: 420px;
background-color: #FFFFFF;
justify-content: center;
align-items: center;
border-radius: 16px;
box-shadow: rgba(145, 158, 171, 0.08) 0px 0px 2px 0px, rgba(145, 158, 171, 0.08) 0px 12px 24px -4px;
`